import {Component, Input, OnInit, Output, ViewChild, EventEmitter} from '@angular/core';
import {ConcretePricesService} from "../../../../../features/financial/data/concrete-prices.service";
import {PriceRulesTranslationKeys} from '../helpers/PriceRulesTranslationKeys';
import {PriceRuleEntity} from 'src/app/features/financial/price_rules/entities';
import {HttpParams} from "@angular/common/http";
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {ProductType} from '../../../../../features/financial/data/interfaces/price-agreement-rule';

export interface PriceAgreementContext {
  customer_id: number;
  project_id: number;
  product_type: ProductType;
  product_id: number;
  price_before: number;
}

@Component({
  selector: 'jbm-concrete-base-pricerules-breakdown-popover',
  templateUrl: './JBMConcreteBasePriceRulesBreakdownPopover.component.html',
  styleUrls: ['./JBMConcreteBasePriceRulesBreakdownPopover.component.scss']
})
export class JBMConcreteBasePriceRulesBreakdownPopoverComponent implements OnInit {
  PriceRulesTranslationKeys: PriceRulesTranslationKeys;
  pricerules: any[]=[];

  @ViewChild('p') popover: NgbPopover;

  @Input() price: number;
  @Input() project_id: number;
  @Input() customer_id: number;
  @Input() plant_id: number;
  @Input() environment_id: number;
  @Input() strength_id: number;
  @Input() consistency_id: number;
  @Input() allowPriceAgreement: boolean;
  @Input() product_type: ProductType;
  @Input() product_id: number;
  @Input() class: string;

  @Output() OnCreatePriceAgreement: EventEmitter<PriceAgreementContext> = new EventEmitter<PriceAgreementContext>();

  constructor(private ConcretePricesService: ConcretePricesService) {
    this.PriceRulesTranslationKeys=new PriceRulesTranslationKeys();
  }

  ngOnInit(): void {
    if(this.price==undefined) this.price=0.0;
    if(this.project_id==undefined) this.project_id=0;
    if(this.customer_id==undefined) this.customer_id=0;
    if(this.plant_id == undefined) this.plant_id = 0;
    if(this.environment_id == undefined) this.environment_id = 0;
    if(this.strength_id == undefined) this.strength_id = 0;
    if(this.consistency_id == undefined) this.consistency_id = 0;
    if(this.allowPriceAgreement == undefined) this.allowPriceAgreement = false;
    if(this.product_type == undefined) this.product_type = ProductType.Concrete;
    if(this.product_id == undefined) this.product_id = 0;
  }
  toggle() {
    if(this.popover.isOpen()) {
      this.popover.toggle();
      return;
    }
    if(!this.popover.isOpen() && this.pricerules.length>0) {
      this.popover.toggle();
      return;
    }
    let params=new HttpParams()
        .append('projects_id',this.project_id.toString())
        .append('customers_id', this.customer_id.toString())
        .append('plants_id', this.plant_id.toString())
        .append('environments_id','-1')
        .append('strengths_id', '-1')
        .append('consistencies_id', '-1');
    this.ConcretePricesService.calculateBasePrice(params).subscribe(
        (data: any)=>this.pricerules=data.data.pricerules,
        (error: any)=>console.error(error),
        ()=> {
          this.pricerules=this.PriceRulesTranslationKeys.setKeys(this.pricerules);
          this.toggle();
        }
    )
  }
  priceAgreementClick() {
    this.OnCreatePriceAgreement.emit({
      customer_id: this.customer_id,
      project_id: this.project_id,
      product_type: this.product_type,
      product_id: this.product_id,
      price_before: this.price
    });
  }

  readonly PriceRuleEntity=PriceRuleEntity;
}
